import { FC } from 'react'

import { formatCurrencyCent, reportPercents } from 'commons/utils'
import { Layer, PageSectionSecondary } from 'ui/components'

import { HRRBankAccount } from '../../../../types'
import { renderLicensesList } from './helpers'

import * as SC from './styles'

export const SalesReportTable: FC<{ bankAccount: HRRBankAccount }> = ({ bankAccount }) => {
  const { showSalesRetail, showSalesWholesale } = bankAccount

  return (
    <PageSectionSecondary face="outlined" title="Cannabis Sales Report">
      <Layer shadowed rounded stretch>
        <SC.Table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Name</th>
              <th>{showSalesWholesale && <>Wholesale ({renderLicensesList(showSalesWholesale)})</>}</th>
              <th>{showSalesRetail && <>Retail ({renderLicensesList(showSalesRetail)})</>}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Current Period</td>
              <td>{showSalesWholesale && formatCurrencyCent(showSalesWholesale.currentPeriod.total, false)}</td>
              <td>{showSalesRetail && formatCurrencyCent(showSalesRetail.currentPeriod.total, false)}</td>
            </tr>
            <tr>
              <td>Prior Period</td>
              <td>{showSalesWholesale && formatCurrencyCent(showSalesWholesale.priorPeriod.total, false)}</td>
              <td>{showSalesRetail && formatCurrencyCent(showSalesRetail.priorPeriod.total, false)}</td>
            </tr>
            <tr>
              <td>Peer Group Average</td>
              <td>{showSalesWholesale && formatCurrencyCent(showSalesWholesale.peerGroupAverage.total, false)}</td>
              <td>{showSalesRetail && formatCurrencyCent(showSalesRetail.peerGroupAverage.total, false)}</td>
            </tr>
            <tr>
              <td>% Change</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Prior Period</td>
              <SC.Td $alerted={showSalesWholesale && showSalesWholesale.changesPriorPeriod.total.alerted}>
                {showSalesWholesale && reportPercents(showSalesWholesale.changesPriorPeriod.total.percent)}
              </SC.Td>
              <SC.Td $alerted={showSalesRetail && showSalesRetail.changesPriorPeriod.total.alerted}>
                {showSalesRetail && reportPercents(showSalesRetail.changesPriorPeriod.total.percent)}
              </SC.Td>
            </tr>
          </tbody>
        </SC.Table>
      </Layer>
    </PageSectionSecondary>
  )
}
